import React from 'react';
import { render } from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import injectTapEventPlugin from 'react-tap-event-plugin';
import { StyleSheet } from 'aphrodite';

import Root from './Root';

injectTapEventPlugin();

const root = document.querySelector('#root');

StyleSheet.rehydrate(window.renderedClassNames);
const mount = (RootComponent) => {
  render(
    <AppContainer>
      <RootComponent />
    </AppContainer>,
    root
  );
};

if (module.hot) {
  module.hot.accept('./Root', () => {
    // eslint-disable-next-line global-require,import/newline-after-import
    const RootComponent = require('./Root').default;
    mount(RootComponent);
  });
}

mount(Root);



// WEBPACK FOOTER //
// /src/client/index.js